module.exports = __webpack_public_path__ + "static/img/title.bf284344.png";